import { render, staticRenderFns } from "./DialogItemSettings.vue?vue&type=template&id=f9f10890&scoped=true"
import script from "./DialogItemSettings.vue?vue&type=script&lang=js"
export * from "./DialogItemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f10890",
  null
  
)

export default component.exports